'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LogoutController = function LogoutController($state, $scope, $rootScope, $location, $http, $cookieStore) {
  _classCallCheck(this, LogoutController);

  this.name = 'Logout';
  this.form = 'Logout';

  $http.get(WEBSERVICEURL + '/dataagility/api/service.function/init').then(function successCallback(response) {
    $scope.vm.logOutAppFunction = response.data.find(function (x) {
      return x.code === 'LOGOUT';
    });
    if ($scope.vm.logOutAppFunction && $scope.vm.logOutAppFunction.valueString) {
      $scope.vm.loginURL = $scope.vm.logOutAppFunction.valueString;
    } else {
      $scope.vm.loginURL = window.location.hostname + '/v2/login';
    }
  });
  localStorage.clear();
  $cookieStore.remove('globals');
  $cookieStore.remove('globals');
  $cookieStore.remove('globals');
  $cookieStore.remove('io');
};

exports.default = LogoutController;


// WEBPACK FOOTER //
// ./client/app/components/logout/logout.controller.js